import { ArrowRight, Phone } from "lucide-react";

export const TRUCK_IMG = "/videos/road_poster.jpg";

export default function EditorialIntro() {
  return (
    <section id="about" className="scroll-mt-24 bg-white py-20 sm:py-28" data-testid="editorial-intro">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="grid items-center gap-12 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <p className="flex items-center gap-2 text-xs font-semibold text-slate-500">
              <span className="h-2 w-2 rounded-full bg-saffron" /> About IndiaFast
            </p>
            <h2 className="mt-5 font-heading text-4xl font-medium leading-[1.06] tracking-tight text-navy sm:text-5xl lg:text-6xl">
              Your shipment.<br />Our mission.<br />
              <span className="text-saffron">Welcome to IndiaFast.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-3xl border border-stone-200 bg-white shadow-xl shadow-stone-200">
              <img src={TRUCK_IMG} alt="IndiaFast branded delivery truck" loading="lazy"
                   className="kenburns-a h-72 w-full object-cover sm:h-80" />
            </div>
          </div>
        </div>
        <div className="mt-10 grid items-end gap-8 lg:grid-cols-12">
          <div className="flex flex-wrap gap-3 lg:col-span-7">
            <a href="#services" data-testid="intro-discover-btn"
               className="group inline-flex items-center gap-2 rounded-full bg-saffron py-2 pl-6 pr-2 text-sm font-bold text-white transition-colors hover:bg-saffron-hover">
              Our services
              <span className="grid h-8 w-8 place-items-center rounded-full bg-white/20 transition-transform group-hover:translate-x-0.5">
                <ArrowRight className="h-4 w-4" />
              </span>
            </a>
            <a href="tel:9783807838" data-testid="intro-talk-team-btn"
               className="group inline-flex items-center gap-2 rounded-full border border-stone-300 bg-white py-2 pl-6 pr-2 text-sm font-bold text-navy transition-colors hover:border-saffron hover:text-saffron">
              <Phone className="h-4 w-4" /> Talk to our team
              <span className="grid h-8 w-8 place-items-center rounded-full bg-saffron/10 text-saffron transition-colors group-hover:bg-saffron group-hover:text-white">
                <ArrowRight className="h-4 w-4" />
              </span>
            </a>
          </div>
          <p className="max-w-xl text-sm leading-relaxed text-slate-500 sm:text-base lg:col-span-5" data-testid="intro-stat-card">
            IndiaFast Global Couriers helps individuals and businesses move documents, parcels and commercial
            shipments from India to destinations around the world — with reliable service, transparent
            communication and dedicated human support at every step.
          </p>
        </div>
      </div>
    </section>
  );
}
